import {MiddlewareContext} from '@/lib/middleware'
import {App} from '@/project'
import {RootState} from '@/store'

interface LayoutMiddlewareOptions {
  footer?: any
  header?: any
  background?: string
}

/**
 * Runs when the router meta.middleware is 'layout'
 * @param ctx
 * @param options
 */
export function beforeEnter(
  ctx: MiddlewareContext<App, RootState>,
  options: LayoutMiddlewareOptions = {}) {
  const {footer, header, background = 'white'} = options
  const {store} = ctx

  if(!store || !store.state.layout) {
    throw new Error('[middleware layout] need to store')
  }

  store.commit('layout/updateRouting', true)

  store.commit('layout/header/clear')
  store.commit('layout/footer/clear')

  if(background) {
    store.commit('layout/updateBackground', background)
  } else {
    store.commit('layout/updateBackground', background)
  }

  if(footer) {
    store.commit('layout/footer/active', true)
    store.commit('layout/footer/update', footer)
    if(footer.buttons) {
      store.commit('layout/footer/addButton', footer.buttons)
    }
  }

  if(header) {
    store.commit('layout/header/active', true)
    store.commit('layout/header/update', header)
  }
  return ctx.next()
}
